export default __webpack_public_path__ + "c23d9e7010330830384f4a74cfad50e6.gif";